const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

// Helper function for API calls
async function apiCall(endpoint, options = {}) {
  const url = `${API_URL}${endpoint}`;
  const response = await fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ detail: 'Unknown error' }));
    throw new Error(error.detail || `API Error: ${response.status}`);
  }

  return response.json();
}

// Upload document
export async function uploadDocument(file) {
  const formData = new FormData();
  formData.append('file', file);

  const response = await fetch(`${API_URL}/api/documents/upload`, {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ detail: 'Upload failed' }));
    throw new Error(error.detail || 'Upload failed');
  }

  return response.json();
}

// List documents
export async function listDocuments(params = {}) {
  const queryParams = new URLSearchParams();
  
  if (params.status) queryParams.append('status', params.status);
  if (params.classification) queryParams.append('classification', params.classification);
  if (params.priority) queryParams.append('priority', params.priority);
  if (params.q) queryParams.append('q', params.q);
  if (params.skip) queryParams.append('skip', params.skip);
  if (params.limit) queryParams.append('limit', params.limit);

  return apiCall(`/api/documents?${queryParams.toString()}`);
}

// Get document details
export async function getDocument(id) {
  return apiCall(`/api/documents/${id}`);
}

// Reprocess document
export async function reprocessDocument(id) {
  return apiCall(`/api/documents/${id}/process`, { method: 'POST' });
}

// Update document fields
export async function updateDocumentFields(id, updates) {
  return apiCall(`/api/documents/${id}/fields`, {
    method: 'PATCH',
    body: JSON.stringify(updates),
  });
}

// Get document PDF URL
export function getDocumentPdfUrl(id) {
  return `${API_URL}/api/documents/${id}/file`;
}

// Export document as JSON
export function getDocumentJsonUrl(id) {
  return `${API_URL}/api/export/${id}.json`;
}

// Export document as CSV
export function getDocumentCsvUrl(id) {
  return `${API_URL}/api/export/${id}.csv`;
}

// Get analytics summary
export async function getAnalyticsSummary() {
  return apiCall('/api/analytics/summary');
}
